export default __webpack_public_path__ + "static/media/contact-image.baed215f.jpg";